import {Select} from '@mui/material';
import React, {useEffect, useState} from 'react';
import {requestStores} from '../../../../ListOfPREditors.brick.jsx';
import PropTypes from 'prop-types';
import {BrickContext} from 'olympe';
import {getAllIncotermsLambda} from '../../../../../utils/functionSignatures';
import MenuItem from '@mui/material/MenuItem';
import {checkLabelValueObject, createLabelValue} from '../../../../../utils/checkObjects';
import CircularProgress from '@mui/material/CircularProgress';
import {LAMBDA_NAMES} from '../../../../../utils/constants';
import {useFieldEditability} from '../../../utils/useFieldEditability.js';
import IconButton from '@mui/material/IconButton';
import ClearIcon from '@mui/icons-material/Clear';

/**
 * @param {IncotermsCode.propTypes} props
 * @return {Element}
 */
export const IncotermsCode = (props) => {
    const useRequestStore = requestStores.get(props.prTag);
    const [incoterms, setIncoterms] = useRequestStore((state) => [state.incoterms, state.setIncoterms]);
    const {isDisabled} = useFieldEditability(props.prTag, {context: props.context});

    const [open, setOpen] = useState(false);
    const [allIncoterms, setAllIncoterms] = useState([]);
    // This useEffect fetch the incoterms list (only on first render, as this list is never updated)
    useEffect(() => {
        let cancelled = false;

        getAllIncotermsLambda(props.context, props.context.get(LAMBDA_NAMES.GET_ALL_INCOTERMS),
            (result) => {
                const parsedResult = JSON.parse(result);
                const populatedIncoterms = parsedResult.length > 0 ? parsedResult.map((r) => createLabelValue(r.description, r.incoterms)) : ['No options'];
                if (populatedIncoterms[0] !== 'No options' && incoterms && incoterms.data?.value !== '' && incoterms.data.value === incoterms.data.label) {
                    const filterdIncoterm = populatedIncoterms.filter((item)=> item.value === incoterms.data.value);
                    if (filterdIncoterm.length > 0) {
                        const newIncoterm = {
                            data: {...filterdIncoterm[0]},
                            manuallyModified: incoterms.manuallyModified,
                        };
                        if (!cancelled) setIncoterms(newIncoterm);
                    }
                }
                if (!cancelled) setAllIncoterms(populatedIncoterms);
            },
            (reason) => {
                console.error(reason);
                if (!cancelled) setAllIncoterms(['No options']);
            });

        return () => {
            cancelled = true;
        };
    }, []);

    const handleIncotermsChange = (event) => {
        setIncoterms({data: checkLabelValueObject(allIncoterms.find((incoterm) => incoterm.value === event.target.value)), manuallyModified: true});
    };

    const handleClickOnMenuItem = (event) => {
        if (incoterms?.data?.value === event.target.getAttribute('data-value')) {
            setIncoterms({data: checkLabelValueObject(allIncoterms.find((incoterm) => incoterm.value === event.target.getAttribute('data-value'))), manuallyModified: true});
        }
    };

    const clearSelection = () => {
        setIncoterms({data: null, manuallyModified: true});
    };

    return (
        <div className={'pr-editor-header-details-incoterms-code'} style={{position: 'relative'}}>
            {allIncoterms.length === 0 && <CircularProgress size={22}/>}
            {props.loading ? <CircularProgress size={20} style={{height: 'auto'}} /> : null}
            {(allIncoterms.length > 0) && (
                <>
                    <Select
                        data-cy={'incoterms-code'}
                        fullWidth
                        open={open}
                        onOpen={() => setOpen(true)}
                        onClose={() => setOpen(false)}
                        variant={'standard'}
                        value={incoterms?.data?.value ?? ''}
                        onChange={handleIncotermsChange}
                        renderValue={(value) => value}
                        disabled={props.loading || isDisabled('header.incotermsCode')}
                    >
                        {allIncoterms.map((incoterm) => (
                            <MenuItem
                                data-cy={'incoterms-option'}
                                key={'incoterm_' + incoterm.value}
                                value={incoterm.value}
                                onClick={handleClickOnMenuItem}
                            >
                                {`${incoterm.value} - ${incoterm.label}`}
                            </MenuItem>
                        ))}
                    </Select>
                    {incoterms?.data && incoterms.data.value && (
                        <IconButton
                            size="small"
                            onClick={clearSelection}
                            disableRipple
                            style={{
                                position: 'absolute',
                                right: 15,
                                top: '50%',
                                transform: 'translateY(-50%)',
                            }}
                        >
                            <ClearIcon fontSize="small"/>
                        </IconButton>
                    )}
                </>
            )}
        </div>
    );
};

IncotermsCode.propTypes = {
    context: PropTypes.instanceOf(BrickContext).isRequired,
    prTag: PropTypes.string.isRequired,
    loading: PropTypes.bool,
};
